import { render, staticRenderFns } from "./formGuiaDespachoExportacion.vue?vue&type=template&id=18d16f9a&scoped=true"
import script from "./formGuiaDespachoExportacion.vue?vue&type=script&lang=js"
export * from "./formGuiaDespachoExportacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d16f9a",
  null
  
)

export default component.exports